module.exports = __webpack_public_path__ + "img/glasses-9-1.890ea270.svg";